// noinspection JSXUnresolvedComponent
import { revocationValidationRules } from "./revocation.validation.rules";

import Header from "../../../../../layout/Header/Header";
import Breadcrumbs from "../../../../../common/Breadcrumbs/Breadcrumbs";
import Footer from "../../../../../layout/Footer/Footer";
import IC from "../../../../../common/compositions/InputComposition/IC";
import ModalBanOverlay from "../../../../../common/Modal/ModalBanOverlay/ModalBanOverlay";
import {
    sendToRevokeDelegationThunkAction,
} from "../../../../../../redux/actions/MyDivision/Delegation/AuthorityRevocation/thunk/sendToRevokeDelegation.thunk.action";
import SimpleDropdown
    from "../../../../../common/compositions/InputComposition/dropdown.types/SimpleDropdown/SimpleDropdown";

import InputCompositionContext from "../../../../../../hooks/useInputCompositionContext/useInputCompositionContext";

import OkButton from "../../../../../common/Button/OKButton/OKButton";

import DelegationInProgressItem
    from "../../../../../common/compositions/InputComposition/dropdownItems.types/DelegationInProgressItem/DelegationInProgressItem";
import {
    clearErrorNotificationContentAction,
} from "../../../../../../redux/actions/MyDivision/Delegation/AuthorityDelegation/clearErrorNotificationContent.action";

import {
    getActiveDelegationsThunkAction,
} from "../../../../../../redux/actions/MyDivision/Delegation/AuthorityDelegation/thunk/getActiveDelegations.thunk.action";

import {
    clearActiveDelegations,
} from "../../../../../../redux/actions/MyDivision/Delegation/AuthorityDelegation/clearActiveDelegations.action";
import FrontendFormValidationService from "../../../../../../frontend.services/FrontendFormValidation.service";

import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import "./AuthorityRevocation.scss";

const AuthorityRevocation = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const delegationsInProgress = useSelector(state => state.myDivision.activeSubstitution)

    const errorNotificationContent = useSelector(state => state.myDivision.errorNotificationContent);

    const [revocationState, setRevocationState] = useState({});
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [modalSuccess, setModalSuccess] = useState(false);
    const [notification, setNotification] = useState(false);

    const context = [revocationState, setRevocationState, isError, setIsError];

    function backButtonHandler() {
        navigate("/divisions/structure/delegation");
    }

    function submitHandler() {
        const validation = new FrontendFormValidationService(revocationState, isError, setIsError, revocationValidationRules);
        if (validation.validate()) {
            dispatch(sendToRevokeDelegationThunkAction(
                revocationState,
                setIsLoading,
                setModalSuccess,
                setNotification,
            ));
        }
    }

    function closeNotificationHandler() {
        dispatch(clearErrorNotificationContentAction());
        setNotification(false);
    }

    useEffect(() => {
        dispatch(clearActiveDelegations());
        dispatch(getActiveDelegationsThunkAction());
        return()=>{
            dispatch(clearActiveDelegations());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

    }, [errorNotificationContent]);

    console.log(revocationState);
    return (
        <>
            <Header />
            <Breadcrumbs />
            <main className={"revocation-transfer"}>
                <div className={"sub-header"}>
                    {/*Изменение конечной даты замещения*/}
                    Прекращение замещения

                </div>
                <InputCompositionContext.Provider value={context}>

                    <IC
                        require
                        field={"id"}>
                        <IC.Label
                            value={"Выбор замещения"}
                        />
                        <IC.Input />
                        <IC.Dropdown>
                            <SimpleDropdown
                                items={
                                    delegationsInProgress &&
                  delegationsInProgress.length
                                        ? delegationsInProgress
                                        : []
                                }
                            >
                                <DelegationInProgressItem />
                            </SimpleDropdown>
                        </IC.Dropdown>
                        <IC.Error />
                    </IC>

                    <div style={{ display: "flex", gap: "30px" }}>



                        <IC
                            field={"to"}>
                            <IC.Label value={"Дата прекращения замещения"} />
                            {/*TODO PERIOD HIGHLIGHT*/}
                            <IC.DatepickerSelect

                                minDate={
                                    delegationsInProgress && revocationState.id &&
                                    delegationsInProgress.find(delegation => delegation.id === revocationState.id) &&

                                    new Date(
                                    delegationsInProgress.find(delegation => delegation.id === revocationState.id).from
                                    )
                                }
                                // maxDate={
                                //     delegationsInProgress && revocationState.id &&
                                //     delegationsInProgress.find(delegation => delegation.id === revocationState.id) &&
                                //     new Date(
                                //    moment(delegationsInProgress.find(delegation => delegation.id === revocationState.id).to) .add(12,"months")
                                //     )
                                // }
                                checkbox={false} />
                            <IC.Error />
                            {/*<IC.Description*/}
                            {/*    value={"Уберите отметку справа, в случае бессрочного замещения"}/>*/}
                        </IC>

                    </div>

                    <IC field={"comment"}>
                        <IC.Label value={"Комментарий"} />
                        <IC.Input />
                        <IC.Description value={"* - поля обязательные для заполнения"} />
                    </IC>

                </InputCompositionContext.Provider>


                <div style={{ width: "1160px", margin: "60px auto", display: "flex", justifyContent: "space-between" }}>
                    <OkButton
                        title={"назад"}
                        handler={backButtonHandler}
                    />
                    <OkButton
                        onValidation={isLoading}
                        // title={"изменить дату"}
                        title={"сохранить"}

                        handler={submitHandler}
                    />
                </div>

                {
                    notification &&
          errorNotificationContent &&
          errorNotificationContent.length
                        ? <div className={"delegation-transfer__notification"}>
                            <div onClick={closeNotificationHandler}
                                className={"delegation-transfer__notification__cross"}></div>
                            {
                                errorNotificationContent &&
                Array.isArray(errorNotificationContent)
                                    ? errorNotificationContent.map((e, i) => {
                                        return (<div key={i}><p>{e}</p> <br /></div>);
                                    })
                                    : <div>{errorNotificationContent}</div>}
                        </div>
                        : null
                }
            </main>
            <Footer />

            <ModalBanOverlay shown={modalSuccess}>
                <div className={"delegation-modal-status"}>
                    <div style={{ textAlign: "center" }} className={"delegation-modal-status__header sub-header"}>
            Конечная дата успешно изменена
                    </div>
                    <div className={"delegation-modal-status__buttons"}>
                        <OkButton title={"хорошо"} handler={backButtonHandler} />
                    </div>
                </div>
            </ModalBanOverlay>
        </>
    );
};

export default AuthorityRevocation;
